import { ToasterComponent } from '../../../toasterComponent/toasterComponent';
import { Component, ViewContainerRef } from '@angular/core';
import { MDMService } from '../services/mdmService.service';
import { BiUrls } from '../../biUrls';

@Component({
    selector: 'valueStream',
    templateUrl: 'valueStream.component.html'
})

export class ValueStreamComponent {
    public lastRegex: string = '';
    public sPage: number = 0;
    public vsReg: string = '';
    public vsData: any = {
        id: null, name: '', valueStreamCode: null,
        shortDesc: '', longDesc: '', deleted: 0
    };
    public mainPage: boolean = true;
    public vsPage: boolean = false;
    public vsList: any = [];
    public saveButton: boolean = false;
    public accessDenied: boolean = false;
    public onStart: boolean = false;
    public isEdit: boolean = false;
    public pageNo: number = 0;
    public pageSize: number = 10;
    public startingPage: number = 0;
    public currentPage: number = 1;
    public selectedVSId: number;
    public endingPage: number;

    public totalvs: number = 0;
    public totalPages: number = 0;
    public loader: boolean = false;

    constructor(
        public vsService: MDMService, public toastr: ToasterComponent,
        public vcr: ViewContainerRef) {
        this.toastr.setViewRef(vcr);
    }

    public ngOnInit() {
        if (this.vsService.isBIAdmin) {
            this.loadVs();
        } else {
            this.accessDenied = true;
        }
    }

    public entityOps(event) {
        if (this.selectedVSId == null) {
            this.selectedVSId = event.target.id;
        } else {
            this.selectedVSId = null;
        }
    }

    public closeDropDown(event) {
        this.selectedVSId = null;
    }

    // For Pagination
    public onPageChange(event: number): void {
        this.currentPage = event;
        this.pageNo = this.currentPage - 1;
        if (this.vsReg != '') {
            this.searchPValueStream();
        } else {
            this.loadVs();
        }
        this.setEndingPage(this.totalvs);
    }

    public setEndingPage(total) {
        let self = this;
        if (self.currentPage == 1) {
            this.startingPage = 0;
            if (total > this.pageSize) {
                this.endingPage = this.pageSize;
            } else {
                this.endingPage = total;
            }
        } else {
            this.startingPage = 0 + ((self.currentPage - 1) * +this.pageSize);
            this.endingPage = +this.pageSize + ((self.currentPage - 1) * +this.pageSize);
            if (this.endingPage > total) {
                this.endingPage = total;
            }
        }
    }

    // For Pagination
    public OnPageSizeChanged(event) {
        this.pageSize = event.target.value;
        let maxPage = Math.floor(this.totalvs / this.pageSize);
        if (maxPage < this.pageNo || maxPage < this.sPage) {
            this.pageNo = maxPage;
            this.sPage = this.pageNo;
        }
        this.loadVs();
    }

    public loadVs() {
        return new Promise((resolve) => {
            let self = this;
            self.loader = true;
            this.vsService.getDataByPage(BiUrls.VALUESTREAM, self.pageNo, self.pageSize).then((res) => {
                self.vsList = [];
                self.totalPages = 0;
                self.totalvs = 0;
                if (res != undefined) {
                    self.vsList = res.data != undefined &&
                        res.data.pageElements != undefined ? res.data.pageElements :
                        self.toastr.showError('No results found');
                    self.totalvs = res.data != undefined &&
                        res.data.total != undefined ? res.data.total : 0;
                }
                self.setEndingPage(self.totalvs);
                self.mainPage = true;
                self.loader = false;
                resolve('completed');
            }, (err) => {
                console.error(err);
            });
        });
    }

    public addNewVs() {
        this.mainPage = false;
        this.vsPage = true;
        this.vsData = { id: null, name: '', shortDesc: '', longDesc: '', deleted: 0 };
    }

    public searchPValueStream() {
        return new Promise((resolve) => {
            let self = this;
            self.loader = true;
            self.mainPage = true;
            self.vsList = [];
            if (self.vsReg != self.lastRegex) {
                self.sPage = 0;
                self.currentPage = 1;
            } else {
                self.sPage = self.currentPage - 1;
            }
            self.lastRegex = self.vsReg;
            self.vsService.search(BiUrls.VALUESTREAM, BiUrls.SEARCH_P_VALUESTREAM,
                self.vsReg, self.sPage, self.pageSize).then((res) => {
                    self.loadSearchedData(res);
                    self.loader = false;
                }, (error) => {
                    console.error(error);
                });
            resolve('completed');
        });
    }

    public loadSearchedData(res) {
        let self = this;
        self.vsList = (res != undefined) ? res.data.pageElements : [];
        self.totalvs = (res != undefined) ? res.data.total : 0;
        self.setEndingPage(self.totalvs);
    }

    public onSave() {
        let validate: any = this.validater();
        if (validate != '') {
            this.toastr.showError(validate);
        } else {
            let self = this;
            self.saveButton = true;
            if (self.isEdit) {
                console.log('ON EDIT');
                self.vsService.update(BiUrls.VALUESTREAM, self.vsData).then((res) => {
                    self.loadAfterSaveOrEdit(res, 'edit');
                });
            } else {
                console.log('ON SAVE');
                self.vsService.save(BiUrls.VALUESTREAM, self.vsData).then((res) => {
                    self.loadAfterSaveOrEdit(res, 'new');
                });
            }
        }
    }

    public loadAfterSaveOrEdit(result, type) {
        let self = this;
        self.totalPages = Math.floor(self.totalvs / self.pageSize);
        self.pageNo = self.isEdit == true ? self.pageNo : self.totalPages;
        self.currentPage = self.pageNo + 1;
        let text = type == 'new' ?
            'Value Stream saved successfully' :
            'Changes saved successfully';

        if (self.vsReg != '') {
            self.searchPValueStream().then((res) => {
                self.setPageFieldsAfterLoading();
                if (result.error == undefined && result.success == true) {
                    self.toastr.showSuccess(text);
                } else {
                    self.toastr.showError(result.statusText);
                }
            })
        } else {
            self.loadVs().then((res) => {
                self.setPageFieldsAfterLoading();
                if (result.error == undefined && result.success == true) {
                    self.toastr.showSuccess(text);
                } else {
                    self.toastr.showError(result.statusText);
                }
            });
        }
    }

    public setPageFieldsAfterLoading() {
        let self = this;
        self.saveButton = false;
        self.mainPage = true;
        self.vsPage = false;
        self.isEdit = false;
    }

    public clickEdit(vs) {
        console.log('On Edit Controller ...');
        let self = this;
        self.loader = true;
        self.selectedVSId = null;
        self.vsService.getDataById(BiUrls.VALUESTREAM, vs.id).then((res) => {
            if (res == undefined || (res.error != undefined && res.status != true)) {
                self.toastr.showError('Cannot load Value stream');
                self.mainPage = true;
            } else {
                vs = res.data;
                self.isEdit = true;
                self.mainPage = false;
                self.vsPage = true;
                self.vsData = JSON.parse(JSON.stringify(vs));
            }
            self.loader = false;
        });
    }

    public onBack() {
        this.mainPage = true;
        this.vsPage = false;
        this.vsData = {};
        this.isEdit = false;
        this.selectedVSId = null;
    }

    public delete(vs) {
        let self = this;
        self.vsService.delete(BiUrls.VALUESTREAM, vs.id).then((response) => {
            self.loader = false;
            self.pageNo = self.vsList.length == 1 ?
                self.totalvs == 1 ? 0 : --self.pageNo : self.pageNo;
            self.loadVs();
            if (response != undefined) {
                self.toastr.showSuccess(vs.name + ' removed successfully');
            } else {
                self.toastr.showError('Unable to remove Value Stream ');
            }
        }, (error) => {
            console.log(error);
        });
    }

    public removeVs(vs) {
        let r = confirm('Are you sure you want to remove the value stream ' + vs.name + ' ?');
        if (r == true) {
            this.delete(vs);
        }
        this.selectedVSId = null;
    }

    public validater() {
        if (this.vsData.name == undefined ||
            this.vsData.name.trim() == '') {
            return 'Please enter the name for Value Stream';
        } else {
            this.vsData.name = this.vsData.name.trim();
            this.vsData.shortDesc = this.vsData.shortDesc != undefined ?
                this.vsData.shortDesc.trim() : null;
            this.vsData.longDesc = this.vsData.longDesc ? this.vsData.longDesc.trim() : null;
            return '';
        }

    }

}



// WEBPACK FOOTER //
// ./src/app/bi/admin/controller/valueStream.component.ts